import { createSlice } from "@reduxjs/toolkit";

export const counterSlice = createSlice({
  name: "keyResources",
  initialState: {
    keyResourceList: [],
    pinArray:[]
  },
  reducers: {
    loadKeyResources: () => {},
    loadKeyResourcesSuccess: (state, action) => {
      state.keyResourceList = action.payload.data;
    },
    setKeyResources: (state, action) => {
      state.keyResourceList = action.payload;
    },
    loadKeyResourcesFailure: () => {},
    addKeyResource :() => {},
    editKeyResource :() => {},
    loadPins :() => {},
    setPins: (state, action) => {
      state.pinArray = action.payload;
    },
    markPin:()=>{}
  },
});

export const {
  loadKeyResources,
  loadKeyResourcesSuccess,
  loadKeyResourcesFailure,
  addKeyResource,
  editKeyResource,
  setPins,
  loadPins,
  setKeyResources,
  markPin
} = counterSlice.actions;

export default counterSlice.reducer;

export const getKeyResources = (state) => state.keyResources.keyResourceList;

export const pinsLength = (state) => state.keyResources.pinArray.length;




